
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"m17.6678 4.35291h-12.07937c-.6865 0-1.34487.2727-1.8303.75813-.48542.48542-.75813 1.1438-.75813 1.83029v8.62807c0 .6865.27271 1.3449.75813 1.8303.48543.4854 1.1438.7582 1.8303.7582h12.07937c.6865 0 1.3448-.2728 1.8303-.7582.4854-.4854.7581-1.1438.7581-1.8303v-8.62807c0-.68649-.2727-1.34487-.7581-1.83029-.4855-.48543-1.1438-.75813-1.8303-.75813zm-.5781 1.72561-5.4616 4.09838-5.46159-4.09838zm.5781 10.35368h-12.07937c-.22883 0-.44829-.0909-.6101-.2527s-.25271-.3812-.25271-.6101v-8.41236l6.38478 4.78856c.1494.112.331.1726.5177.1726s.3683-.0606.5177-.1726l6.3848-4.78856v8.41236c0 .2289-.0909.4483-.2527.6101-.1619.1618-.3813.2527-.6101.2527z","fill":"#4a3428"}}),_c('rect',{attrs:{"fill":"#4a3428","height":"6.47107","rx":"3.23554","width":"6.47107","x":"12.3472","y":"13.2347"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"m13.6954 16.7399h3.7748c.1489 0 .2696-.1207.2696-.2696s-.1207-.2696-.2696-.2696h-3.7748c-.1489 0-.2696.1207-.2696.2696s.1207.2696.2696.2696z","fill":"#fff","fill-rule":"evenodd"}})])
          )
        }
      }
    